import { DeviceUseStatementCode } from '@quromedical/fhir-common';
import { DeviceAssociationTable, DeviceAssociationGetResponse } from '@quromedical/models';
import { orderby } from '@quromedical/utils';
import { DeviceUseStatement } from 'fhir/r4';
import { strings } from 'strings';

export const deviceUseStatementCodeDisplayMap: Record<DeviceUseStatementCode, string> = {
  [DeviceUseStatementCode.patch]: strings.DisplayDeviceTypePatch,
  [DeviceUseStatementCode.band]: strings.DisplayDeviceTypeBand,
  [DeviceUseStatementCode.relay]: strings.DisplayDeviceTypeRelay,
  [DeviceUseStatementCode.glucose]: strings.DisplayDeviceTypeGlucose,
  [DeviceUseStatementCode.bloodPressure]: strings.DisplayDeviceTypeBloodPressure,
};

export const orderDeviceUseStatementsByTimeStart = (
  deviceUseStatements: DeviceUseStatement[]
): DeviceUseStatement[] =>
  orderby(deviceUseStatements, [dus => new Date(dus.timingPeriod?.start || '').getTime()], 'desc');

export const getDeviceUseStatementTypeDisplayName = (
  type?: DeviceUseStatementCode
): string | undefined => {
  if (!type) {
    return undefined;
  }
  return deviceUseStatementCodeDisplayMap[type];
};

export const mapDeviceAssociationToTable = (
  association: DeviceAssociationGetResponse
): Partial<DeviceAssociationTable> => {
  const { id, device, patient, status, period, code } = association;

  const start = period?.start ? new Date(period?.start) : undefined;
  const end = period?.end ? new Date(period?.end) : undefined;
  const type = getDeviceUseStatementTypeDisplayName(code);
  const isActive = status !== 'completed' && status !== 'stopped';

  return {
    id,
    code,
    device,
    end,
    start,
    isActive,
    status,
    patient,
    type,
  };
};
